module.exports = __webpack_public_path__ + "static/media/icon_arrow_left.cd4e9994.svg";